import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = ["href", "onClick"];
const _hoisted_2 = {
    key: 1,
    class: "cursor-pointer"
};
import { Breadcrumb } from "primevue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UBreadcrumbs',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createBlock(_unref(Breadcrumb), { model: __props.items }, {
                item: _withCtx(({ item, props }) => [
                    (item.route)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: item.route,
                            custom: ""
                        }, {
                            default: _withCtx(({ href, navigate }) => [
                                _createElementVNode("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
                                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                ], 16, _hoisted_1)
                            ]),
                            _: 2
                        }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.label), 1))
                ]),
                _: 1
            }, 8, ["model"]));
        };
    }
});
